import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import PleaseWait from '../Shared/PleaseWait';
import EditIcon from '@material-ui/icons/Edit';
import Card from '../Card/Card.js';
import CardBody from '../Card/CardBody.js';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { logException } from '../../services/appInsights';
import loginPageStyle from '../../assets/jss/nextjs-material-kit-pro/pages/loginPageStyle.js';
import { callApi } from '../../util/apiWrapper';
import {
  convertSiteCode,
  isAdmin,
  isAdminOrFHT,
  isAftercareSpecialist,
  isAlumni,
  isFHT,
  isScholarshipCoordinator,
  isStudent,
} from '../../util/miscUtil';
import PhoneDialog from './DialogComponents/PhoneDialog';
import { btNavyBlueColor } from '../../assets/jss/nextjs-material-kit-pro';
import useAuthRedirect from '../../hooks/authRedirectHook';
import Button from '../CustomButtons/Button';
import { fetchWorkbookModules } from '../../utils/fetchWorkbookModules';
import Workbook from '../SeniorList/SeniorPlannerComponents/Workbook';
import useSeniorPlannerStyles from '../SeniorList/SeniorPlanner.styles';
import WorkbookModule from '../SeniorList/SeniorPlannerComponents/WorkbookModule';
import PATH from '../../constants/paths';
import { fetchAwardPaymentRequests } from '../Pages/AwardPaymentRequestsSummary';
import { normalizePaymentRequestStatus } from '../AwardPayment/paymentRequestStatuses';
import { AWARD_PAYMENT } from '../../constants/general';

const pageStyles = makeStyles(loginPageStyle);

const useStyles = makeStyles((theme) => ({
  frame: {
    width: '100vw',
  },
  alignMenu: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  menu: {
    margin: '0 auto 0 auto',
    [theme.breakpoints.up('md')]: {
      maxWidth: '1320px',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '380px',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
  },
  welcome: {
    margin: '20px 0 10px 0',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.95rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.55rem',
    },
  },
  cardGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.50em 2.00em',
  },
  menuTitle: {
    fontSize: 24,
    textAlign: 'left',
    margin: '10px 0',
    color: 'blue',
  },
  menuDesc: {
    fontSize: 16,
    textAlign: 'left',
    padding: '0 5px 15px 0',
  },
  statLink: {
    fontSize: '0.80rem',
    color: 'blue',
    cursor: 'pointer',
  },
  statName: {
    fontSize: '0.80rem',
  },
  statValue: {
    fontSize: '0.80rem',
    fontWeight: 500,
  },
  progressMeter: {
    padding: '1%',
    fontSize: '20px',
    height: '30px',
    color: '#fff',
    width: '95%',
  },
  cardSize: {
    maxWidth: '400px',
    height: '300px',
  },
  pointerCursor: {
    cursor: 'pointer',
  },
  phoneButton: {
    paddingLeft: 20,
  },
  editButton: {
    fontSize: '1.10rem',
    paddingBottom: 3,
  },
  space20: {
    marginLeft: 20,
  },
  specialistPhone: {
    fontWeight: 'bold',
    display: 'inline-block',
    marginBottom: 5,
  },
  myModulesWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '10px',
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '-10px',
    },
  },
  myModulesButton: {
    width: '261px',
    height: '48px',
    borderRadius: '156px',
    border: '1.5px solid inherit',
    background: '#CF4520',
    color: '#FFF',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      width: '200px',
      height: '44px',
      fontSize: '13px',
    },
  },
}));

const Index = inject(
  'SeniorStore',
  'AuthStore'
)(
  observer((props) => {
    const store = props.SeniorStore;
    const auth = props.AuthStore;
    const history = useHistory();

    const classes = useStyles();
    const workbookClasses = useSeniorPlannerStyles();
    const pageClasses = pageStyles();

    const [year, setYear] = useState('');
    const [totalSeniors, setTotalSeniors] = useState(0);
    const [activeSeniors, setActiveSeniors] = useState(0);
    const [studentsSubmittedScholarshipApps, setStudentsSubmittedScholarshipApps] = useState(0);
    const [studentsAppliedAftercareTradelife, setStudentsAppliedAftercareTradelife] = useState(0);
    const [studentsAppliedAftercareHousing, setStudentsAppliedAftercareHousing] = useState(0);

    const [total123Modules, setTotal123Modules] = useState(0);
    const [seniorsCompletedModule123, setSeniorsCompletedModule123] = useState(0);
    const [total4567Modules, setTotal4567Modules] = useState(0);
    const [seniorsCompletedModule4567, setSeniorsCompletedModule4567] = useState(0);

    const [tradelifeApps, setTradelifeApps] = useState(0);
    const [housingApps, setHousingApps] = useState(0);
    const [tradelifeSubmittedApps, setTradelifeSubmittedApps] = useState(0);
    const [tradelifeInterviewApps, setTradelifeInterviewApps] = useState(0);
    const [housingSubmittedApps, setHousingSubmittedApps] = useState(0);
    const [housingInterviewApps, setHousingInterviewApps] = useState(0);

    const [newScholarshipApplications, setNewScholarshipApplications] = useState(0);
    const [reviewedScholarshipApplications, setReviewedScholarshipApplications] = useState(0);
    const [underReviewScholarshipApplications, setUnderReviewScholarshipApplications] = useState(0);

    // Award payment request summary counts for scholarship coordinators
    const [totalNumberOfRequest, setTotalNumberOfRequest] = useState(0);
    const [noOfRequestInPending, setNoOfRequestInPending] = useState(0);
    const [noOfRequestUnderReview, setNoOfRequestUnderReview] = useState(0);
    const [noOfRequestApprovedPendingPayment, setNoOfRequestApprovedPendingPayment] = useState(0);

    const [totalPendingHelpApplications, setTotalPendingHelpApplications] = useState(0);
    const [totalClosedHelpApplications, setTotalClosedHelpApplications] = useState(0);

    const [totalPendingContacts, setTotalPendingContacts] = useState(0);
    const [totalClosedContacts, setTotalClosedContacts] = useState(0);

    const [totalAlumni, setTotalAlumni] = useState(0);
    const [accessRequests, setAccessRequests] = useState(0);
    const [deniedAccessRequests, setDeniedAccessRequests] = useState(0);

    const [showDialog, setShowDialog] = useState(false);

    const [staff, setStaff] = useState(null);
    const [warning, setWarning] = useState(null);

    const [workbookModuleList, setWorkbookModuleList] = useState([]);
    const [workbookModule, setWorkbookModule] = useState({});
    const [workbookModuleNumber, setWorkbookModuleNumber] = useState(0);
    const [moduleCourseList, setModuleCourseList] = useState([]);
    const [allResources, setAllResources] = useState([]);
    const [page, setPage] = useState('home');

    useEffect(() => {
      setYear(new Date().getFullYear());
    }, []);

    useEffect(() => {
      let cancelled = false;

      const withTimeout = (promise, timeoutMs, label) => {
        return Promise.race([
          promise,
          new Promise((_, reject) => {
            setTimeout(() => reject(new Error(`${label} timed out after ${timeoutMs}ms`)), timeoutMs);
          }),
        ]);
      };

      const safeCall = async (label, task, fallbackValue) => {
        try {
          return await withTimeout(Promise.resolve().then(task), 30000, label);
        } catch (err) {
          console.warn(`Dashboard load failed for ${label}:`, err);
          logException(err);
          return fallbackValue;
        }
      };

      const safeTask = async (label, task) => {
        try {
          await withTimeout(Promise.resolve().then(task), 30000, label);
        } catch (err) {
          console.warn(`Dashboard load failed for ${label}:`, err);
          logException(err);
        }
      };

      const toCsvParam = (value) => {
        if (!value) return '';
        if (Array.isArray(value)) return value.filter(Boolean).join(',');
        try {
          return Array.from(value).filter(Boolean).join(',');
        } catch {
          return String(value);
        }
      };

      const email = auth?.user?.result?.email;

      const fetchStaff = async (staffId) => {
        if (!staffId) return null;
        const staff = await callApi(auth, 'staff/user/' + staffId, 'GET');
        return staff;
      };

      const fetchStaffSites = async () => {
        if (!email) return Array.from(store.staffsites ?? []);
        if (store.staffsites.length > 0) return Array.from(store.staffsites);
        const sites = await callApi(auth, 'staff/sites/' + email, 'GET');
        const siteList = (sites?.result ?? []).map((s) => convertSiteCode(s.node_id)).filter(Boolean);
        if (!cancelled) store.setStaffSites(siteList);
        return siteList;
      };

      const fetchStaffStudents = async () => {
        if (!email) return Array.from(store.staffstudents ?? []);
        if (store.staffstudents.length > 0) return Array.from(store.staffstudents);
        const students = await callApi(auth, 'staff/student-access/' + email, 'GET');
        let studentList = [];
        (students?.result ?? []).forEach((st) => {
          studentList.push(st.intId);
        });
        if (!cancelled) store.setStaffStudents(studentList);
        return studentList;
      };

      const fetchStudentStats = async (siteList, studentList) => {
        const siteListParam = encodeURIComponent(toCsvParam(siteList));
        const studentListParam = encodeURIComponent(toCsvParam(studentList));
        const stats = await callApi(auth, `student/dashboard?siteList=${siteListParam}&studentList=${studentListParam}`, 'GET');
        if (cancelled) return;
        setTotalSeniors(stats.totalSeniors);
        setActiveSeniors(stats.activeSeniors);
        setStudentsSubmittedScholarshipApps(stats.studentsSubmittedScholarshipApps);
        setStudentsAppliedAftercareTradelife(stats.studentsAppliedAftercareTradelife);
        setStudentsAppliedAftercareHousing(stats.studentsAppliedAftercareHousing);
        store.setTotalUniqueSeniors(stats.totalSeniors);
        store.setActiveSeniors(stats.activeSeniors);
      };

      const fetchStudentStatsForFHT = async (siteList, studentList) => {
        const siteListParam = encodeURIComponent(toCsvParam(siteList));
        const studentListParam = encodeURIComponent(toCsvParam(studentList));
        const stats = await callApi(auth, `fht/student/dashboard?siteList=${siteListParam}&studentList=${studentListParam}`, 'GET');
        if (cancelled) return;
        setTotalSeniors(stats.totalSeniors);
        setActiveSeniors(stats.activeSeniors);
        setTotal123Modules(stats.total123Modules);
        setSeniorsCompletedModule123(stats.seniorsCompletedModule123);
        setTotal4567Modules(stats.total4567Modules);
        setSeniorsCompletedModule4567(stats.seniorsCompletedModule4567);
        store.setTotalUniqueSeniors(stats.totalSeniors);
        store.setActiveSeniors(stats.activeSeniors);
        store.setTotal123Modules(stats.total123Modules);
        store.setTotal4567Modules(stats.total4567Modules);
        store.setTotal123ModulesCompleted(stats.seniorsCompletedModule123);
        store.setTotal4567ModulesCompleted(stats.seniorsCompletedModule4567);
      };

      const fetchAlumniStats = async (siteList) => {
        const siteListParam = encodeURIComponent(toCsvParam(siteList));
        const alumniStats = await callApi(auth, `alumni/dashboard?siteList=${siteListParam}`, 'GET');
        if (cancelled) return;
        setTotalAlumni(alumniStats.totalAlumni);
        setAccessRequests(alumniStats.pendingAccessRequests);
        setDeniedAccessRequests(alumniStats.deniedAccessRequests);
      };

      const fetchAftercareStats = async (siteList, studentList) => {
        const siteListParam = encodeURIComponent(toCsvParam(siteList));
        const studentListParam = encodeURIComponent(toCsvParam(studentList));
        const aftercareStats = await callApi(auth, `aftercare/dashboard?siteList=${siteListParam}&studentList=${studentListParam}`, 'GET');
        if (cancelled) return;
        setTradelifeApps(aftercareStats.tradelifeApps);
        setTradelifeSubmittedApps(aftercareStats.tradelifeSubmittedApps);
        setTradelifeInterviewApps(aftercareStats.tradelifeInterviewApps);
        setHousingApps(aftercareStats.housingApps);
        setHousingSubmittedApps(aftercareStats.housingSubmittedApps);
        setHousingInterviewApps(aftercareStats.housingInterviewApps);
      };

      const fetchScholarshipStats = async (siteList, studentList) => {
        const siteListParam = encodeURIComponent(toCsvParam(siteList));
        const studentListParam = encodeURIComponent(toCsvParam(studentList));
        const scholarshipStats = await callApi(auth, `scholarship/dashboard?siteList=${siteListParam}&studentList=${studentListParam}`, 'GET');
        if (cancelled) return;
        setNewScholarshipApplications(scholarshipStats.newApps);
        setReviewedScholarshipApplications(scholarshipStats.reviewedApps);
        setUnderReviewScholarshipApplications(scholarshipStats.qualifiedApps ?? scholarshipStats.readyToReviewApps);
      };

      const fetchHelpStats = async () => {
        const helpRequestStats = await callApi(auth, `helprequest/dashboard`, 'GET');
        if (cancelled) return;
        setTotalPendingHelpApplications(helpRequestStats.pendingApps);
        setTotalClosedHelpApplications(helpRequestStats.closedApps);
      };

      const fetchContactStats = async () => {
        const contactStats = await callApi(auth, `contact/dashboard`, 'GET');
        if (cancelled) return;
        setTotalPendingContacts(contactStats.pendingContacts);
        setTotalClosedContacts(contactStats.closedContacts);
      };

      const fetchAftercareSpecialistList = async () => {
        const specialists = await callApi(auth, 'staff', 'GET');
        if (cancelled) return;
        store.setAftercareSpecialistList(
          (specialists?.result ?? []).filter(
            (s) =>
              s.is_active &&
              (s.position_class === '1347' || s.position_class === '2001' || s.position_class === '2148' || s.position_class === '1534')
          )
        );
      };

      const loadDashboard = async () => {
        if (!(auth && auth.authToken && auth.authToken.length > 0 && auth?.user?.result)) return;

        // Don't load dashboard for students/alumni (they get redirected anyway)
        if (isStudent(auth?.user?.result?.roles) || isAlumni(auth?.user?.result?.roles)) {
          return;
        }

        store.setLoading(true);
        store.setSearching(true);
        try {
          const siteListFallback = Array.from(store.staffsites ?? []);
          const studentListFallback = Array.from(store.staffstudents ?? []);

          const [siteList, studentList] = await Promise.all([
            safeCall('staffSites', fetchStaffSites, siteListFallback),
            safeCall('staffStudents', fetchStaffStudents, studentListFallback),
          ]);

          const tasks = [];

          if (isAdmin(auth.roles)) {
            tasks.push(safeTask('studentStats', () => fetchStudentStats(siteList, studentList)));
            tasks.push(safeTask('alumniStats', () => fetchAlumniStats(siteList)));
            tasks.push(safeTask('aftercareStats', () => fetchAftercareStats(siteList, studentList)));
            tasks.push(safeTask('scholarshipStats', () => fetchScholarshipStats(siteList, studentList)));
            tasks.push(safeTask('helpStats', fetchHelpStats));
            tasks.push(safeTask('contactStats', fetchContactStats));
          } else if (isFHT(auth.roles)) {
            tasks.push(safeTask('studentStatsForFHT', () => fetchStudentStatsForFHT(siteList, studentList)));
          }

          tasks.push(safeTask('aftercareSpecialistList', fetchAftercareSpecialistList));

          const staffId = auth.user.result.id;
          if (staffId) {
            tasks.push(
              safeTask('fetchStaff', async () => {
                const staffData = await fetchStaff(staffId);
                if (!cancelled && staffData?.result) {
                  setStaff(staffData.result);
                }
              })
            );
          }

          await Promise.allSettled(tasks);
        } catch (error) {
          logException(error);
          console.warn('Error loading dashboard data:', error);
        } finally {
          if (!cancelled) {
            store.setSearching(false);
            store.setLoading(false);
          }
        }
      };

      loadDashboard();

      return () => {
        cancelled = true;
      };
    }, [auth, auth.authToken, auth?.user?.result?.email, store]);

    useEffect(() => {
      if (auth.roles && auth.roles.length > 0) {
        if (isStudent(auth.roles) || isAlumni(auth.roles)) {
          history.push('/seniorplanner');
        }
      }
    }, [auth.roles, store, history]);

    useEffect(() => {
      if (staff) {
        if (auth.roles && auth.roles.length > 0) {
          if (isAftercareSpecialist(auth.roles) && (!staff?.office_phone || staff?.office_phone?.length === 0)) {
            setWarning('Your office phone number is not set up. Please add your phone numbers.');
            setShowDialog(true);
          }
        }
      }
    }, [auth.roles, staff]);

    // Redirect user to login page if token is no longer available.
    useAuthRedirect(auth);

    // Factory function for simple navigation handlers
    const createNavigationHandler =
      (path, preAction = null) =>
      () => {
        if (preAction) preAction();
        history.push(path);
      };

    // Factory function for aftercare filter handlers
    const createAftercareFilterHandler = (serviceType, status) => () => {
      store.setAftercareServiceTypeFilter(serviceType);
      store.setAftercareStatusFilter(status);
      history.push('/aftercarelist');
    };

    // Navigation handlers
    const handleViewScholarshipApps = createNavigationHandler('/scholarshiplist');
    const handleViewHelpApps = createNavigationHandler('/helprequestlist');
    const handleViewContacts = createNavigationHandler('/contactlistmainMenu', () => store.setCheckInId(null));
    const handleViewAlumniList = createNavigationHandler('/alumnilist');
    const handleViewAccessRequests = createNavigationHandler('/accessrequestlist');
    const handleViewSeniorList = createNavigationHandler(isFHT(auth.roles) ? '/familyhomelist' : '/seniorlist');
    const handleViewAwardPaymentRequest = createNavigationHandler(PATH.AWARD_PAYMENT_REQUESTS);

    // Aftercare filter handlers
    const handleViewAftercareApps = createAftercareFilterHandler('', '');
    const handleViewTradelifeAftercareApps = createAftercareFilterHandler('tradelife', '');
    const handleViewHousingAftercareApps = createAftercareFilterHandler('housing', '');
    const handleViewTradelifeNewApps = createAftercareFilterHandler('tradelife', 'new');
    const handleViewHousingNewApps = createAftercareFilterHandler('housing', 'new');
    const handleViewTradelifeInterviewApps = createAftercareFilterHandler('tradelife', 'interview');
    const handleViewHousingInterviewApps = createAftercareFilterHandler('housing', 'interview');

    const showUpdateAdminPhoneDialog = () => {
      setShowDialog(true);
    };

    const handleDialogClose = () => {
      setShowDialog(false);
    };

    const handleSavePhone = async (officePhone, cellPhone) => {
      if (!staff) return;
      if (!officePhone) return;

      staff.office_phone = officePhone;
      staff.cell_phone = cellPhone;

      const updatedStaff = await callApi(auth, 'staff', 'PUT', {
        item: staff,
      });
      if (updatedStaff.result) {
        setStaff(updatedStaff.result);
      }
      setWarning('');
      setShowDialog(false);
    };

    const formatPhoneNumber = (str) => {
      //Filter only numbers from the input
      let cleaned = ('' + str).replace(/\D/g, '');

      //Check if the input is of correct length
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }

      return null;
    };

    const handleMyModulesClick = async () => {
      await fetchWorkbookModules({
        auth,
        userId: auth?.user?.result?.id,
        setWorkbookModuleList,
        setPage,
        store,
        logException,
        callApi,
      });

      try {
        const resources = await callApi(auth, 'module/resource', 'GET');
        setAllResources(resources?.result || []);
      } catch (err) {
        logException(err);
        setAllResources([]);
      }
    };

    const openWorkbookModule = async (moduleId, moduleNumber) => {
      const selectedModule = workbookModuleList.find((m) => m.id === moduleId);
      if (!selectedModule) return;

      const courses = extractCoursesFromModule(selectedModule);
      setWorkbookModule(selectedModule);
      setWorkbookModuleNumber(moduleNumber);
      setModuleCourseList(courses);
      setPage('workbookmodule');
    };

    const refreshWorkbook = async () => {
      try {
        const userId = auth?.user?.result?.id;
        if (!userId) return;

        const workbookModules = await callApi(auth, `seniorplan/details/${userId}`, 'GET');
        const modules = (workbookModules?.result || []).flatMap((w) => w.modules || []);
        setWorkbookModuleList(modules);

        const resources = await callApi(auth, 'module/resource', 'GET');
        setAllResources(resources?.result || []);

        if (workbookModule?.id) {
          const currentModule = modules.find((m) => m.id === workbookModule.id);
          if (currentModule) {
            setWorkbookModule(currentModule);
            setModuleCourseList(extractCoursesFromModule(currentModule));
          }
        }
      } catch (err) {
        logException(err);
      }
    };

    const COURSE_STATUS_MAP = {
      completed: { label: 'Completed', color: 'success' },
      registered: { label: 'In Progress', color: 'secondary' },
      default: { label: 'Not Started', color: 'lightblue' },
    };

    const getCourseStatus = (course) => {
      if (course?.completed) return COURSE_STATUS_MAP.completed;
      if (course?.registered) return COURSE_STATUS_MAP.registered;
      return COURSE_STATUS_MAP.default;
    };

    const fetchCourseCompletionStatus = (course) => getCourseStatus(course).label;

    const handleSetButtonColorByRegisteredCompletion = (course) => getCourseStatus(course).color;

    const isCourseLocked = () => false;

    // Factory function to create stat row JSX
    const renderStatRow = (label, value, percentage = null, isLink = false, onClick = null, noWrapLabel = false) => {
      const hasPercentage = percentage !== null;
      const labelGrid = hasPercentage ? { xs: 6, sm: 6, md: 6, lg: 6 } : { xs: 9, sm: 8, md: 8, lg: 8 };
      const valueGrid = hasPercentage ? { xs: 3, sm: 3, md: 3, lg: 3 } : { xs: 3, sm: 3, md: 3, lg: 3 };

      return (
        <Grid
          key={label}
          container
          direction='row'
          style={{ marginBottom: 0 }}
          {...(isLink && onClick && { className: classes.pointerCursor, onClick })}
        >
          <Grid item {...labelGrid} align='left'>
            <summary className={isLink ? classes.statLink : classes.statName} style={noWrapLabel ? { whiteSpace: 'nowrap' } : undefined}>
              {label}
            </summary>
          </Grid>
          <Grid item {...valueGrid} align='right'>
            <summary className={classes.statValue}>{value}</summary>
          </Grid>
          {hasPercentage && (
            <Grid item xs={3} sm={3} md={3} lg={3} align='right'>
              <summary className={classes.statValue}>({percentage}%)</summary>
            </Grid>
          )}
        </Grid>
      );
    };

    // Helper function to extract courses from module steps
    const extractCoursesFromModule = (module) => {
      const courses = [];
      module.steps?.forEach((step) => {
        step.courses?.forEach((course) => {
          courses.push(course);
        });
      });
      return courses;
    };

    const isScholarshipCoordinatorUser = isScholarshipCoordinator(auth.roles, auth?.user?.result?.position_title);

    // Load award payment request summary counts for scholarship coordinators and cache results
    React.useEffect(() => {
      let cancelled = false;
      if (!isScholarshipCoordinatorUser) return;

      const loadAwardRequestSummary = async () => {
        try {
          const requests = await fetchAwardPaymentRequests(auth);
          if (cancelled) return;

          // Cache for AwardPaymentRequestsSummary page to pick up and avoid refetching
          try {
            if (typeof window !== 'undefined') {
              sessionStorage.setItem(AWARD_PAYMENT.AWARD_PAYMENT_REQUESTS_CACHE, JSON.stringify(requests));
            }
          } catch (e) {
            console.warn('Failed to cache award payment requests', e);
          }

          const total = Array.isArray(requests) ? requests.length : 0;
          const pending = requests.filter((r) => normalizePaymentRequestStatus(r.status) === AWARD_PAYMENT.NEED_MORE_INFORMATION).length;
          const underReview = requests.filter((r) => normalizePaymentRequestStatus(r.status) === AWARD_PAYMENT.UNDER_REVIEW).length;
          const approvedPending = requests.filter((r) => normalizePaymentRequestStatus(r.status) === AWARD_PAYMENT.APPROVED).length;

          setTotalNumberOfRequest(total);
          setNoOfRequestInPending(pending);
          setNoOfRequestUnderReview(underReview);
          setNoOfRequestApprovedPendingPayment(approvedPending);
        } catch (err) {
          logException(err);
        }
      };

      void loadAwardRequestSummary();

      return () => {
        cancelled = true;
      };
    }, [isScholarshipCoordinatorUser, auth]);

    return (
      <div className={classes.frame}>
        <div className={classes.alignMenu}>
          <div className={classes.menu}>
            <PleaseWait isLoading={store.loading} />
            {page === 'workbook' ? (
              <Workbook
                workbookModuleList={workbookModuleList}
                allResources={allResources}
                openWorkbookModule={openWorkbookModule}
                setPage={setPage}
                classes={workbookClasses}
                handleSetButtonColorByStatus={() => 'secondary'}
                fetchButtonCompletionStatus={() => 'View'}
                roles={auth.roles || []}
                senior={{}}
                alumni={false}
                handleReturnToSeniorList={() => setPage('home')}
                handleGotoAdminHomepage={() => setPage('home')}
                isStaffMode={true}
              />
            ) : page === 'workbookmodule' ? (
              <WorkbookModule
                moduleCourseList={moduleCourseList}
                workbookModule={workbookModule}
                workbookModuleNumber={workbookModuleNumber}
                allResources={allResources.filter((resource) => resource.module_id === workbookModule.id)}
                fetchCourseCompletionStatus={fetchCourseCompletionStatus}
                setPage={setPage}
                classes={workbookClasses}
                roles={auth.roles || []}
                fetchWorkbook={refreshWorkbook}
                senior={{}}
                alumni={false}
                handleReturnToSeniorList={() => setPage('home')}
                handleGotoAdminHomepage={() => setPage('home')}
                handleSetButtonColorByRegisteredCompletion={handleSetButtonColorByRegisteredCompletion}
                isCourseLocked={isCourseLocked}
                isStaffMode={true}
              />
            ) : (
              <>
                {auth.roles && auth.roles.length > 0 && !auth.notAuthorized && !isStudent(auth.roles) && !isAlumni(auth.roles) && (
                  <React.Fragment>
                    {/* <Typography variant="h4" align="center" className={classes.welcome}>
                  Welcome to Boys Town Successful Futures
                </Typography> */}
                    {isAdminOrFHT(auth.roles) && (
                      <aside
                        style={{
                          marginTop: 5,
                          color: isFHT(auth.roles) && (!staff?.office_phone || staff?.office_phone.length === 0) ? '#FA0000' : btNavyBlueColor,
                        }}
                      >
                        {staff?.office_phone && (
                          <div className={classes.specialistPhone}>
                            <label>Office Phone</label> <span className={classes.contactInfo}>{formatPhoneNumber(staff.office_phone) || 'N/A'}</span>
                          </div>
                        )}{' '}
                        {staff?.cell_phone && <label className={classes.space20}>Cell Phone</label>}{' '}
                        {staff?.cell_phone && (
                          <div className={classes.specialistPhone}>
                            <span className={classes.contactInfo}>{formatPhoneNumber(staff?.cell_phone) || 'N/A'}</span>
                          </div>
                        )}{' '}
                        <Tooltip title='Click to update your phone numbers.' placement='bottom'>
                          <IconButton size='small' aria-label='delete' color='primary' onClick={() => showUpdateAdminPhoneDialog()}>
                            <EditIcon className={classes.editButton} />
                          </IconButton>
                        </Tooltip>
                      </aside>
                    )}
                    <div className={classes.cardGrid}>
                      <Card className={classes.cardSize}>
                        <CardBody>
                          {isAdmin(auth.roles) && (
                            <React.Fragment>
                              <section className={classes.menuTitle + ' ' + classes.pointerCursor} onClick={handleViewSeniorList}>
                                High School Seniors
                              </section>
                              <aside className={classes.menuDesc}>List of high school seniors.</aside>
                              {renderStatRow(
                                'Onboarded',
                                `${activeSeniors} / ${totalSeniors}`,
                                totalSeniors > 0 ? ((activeSeniors / totalSeniors) * 100).toFixed(0) : 0
                              )}
                              {activeSeniors < totalSeniors && (
                                <Grid container direction='row' style={{ marginBottom: 5 }}>
                                  <Grid item xs={12} sm={12} md={12} lg={12} align='left'>
                                    <progress
                                      id='senior-active-meter'
                                      className={classes.progressMeter}
                                      min={0}
                                      max={totalSeniors}
                                      value={activeSeniors}
                                      style={{ width: '100%' }}
                                    ></progress>
                                  </Grid>
                                </Grid>
                              )}
                              {renderStatRow(
                                'Scholarship applicants',
                                studentsSubmittedScholarshipApps,
                                totalSeniors ? ((studentsSubmittedScholarshipApps / totalSeniors) * 100).toFixed(0) : 0
                              )}
                              <Grid container direction='row' style={{ marginBottom: 5 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} align='left'>
                                  <progress
                                    id='scholarship-meter'
                                    className={classes.progressMeter}
                                    min={0}
                                    max={totalSeniors}
                                    value={studentsSubmittedScholarshipApps}
                                    style={{ width: '100%' }}
                                  ></progress>
                                </Grid>
                              </Grid>
                              <Grid container direction='row' style={{ marginBottom: 5 }} />
                              {renderStatRow(
                                'Community Supports applicants',
                                studentsAppliedAftercareTradelife,
                                totalSeniors ? ((studentsAppliedAftercareTradelife / totalSeniors) * 100).toFixed(0) : 0,
                                false,
                                null,
                                true
                              )}
                              {renderStatRow(
                                'Housing applicants',
                                studentsAppliedAftercareHousing,
                                totalSeniors ? ((studentsAppliedAftercareHousing / totalSeniors) * 100).toFixed(0) : 0
                              )}
                            </React.Fragment>
                          )}
                          {isFHT(auth.roles) && (
                            <React.Fragment>
                              <section className={classes.menuTitle + ' ' + classes.pointerCursor} onClick={handleViewSeniorList}>
                                High School Seniors for FHT
                              </section>
                              <aside className={classes.menuDesc}>List of high school seniors for FHT.</aside>
                              {renderStatRow(
                                'Onboarded',
                                `${activeSeniors} / ${totalSeniors}`,
                                totalSeniors > 0 ? ((activeSeniors / totalSeniors) * 100).toFixed(0) : 0
                              )}
                              {activeSeniors < totalSeniors && (
                                <Grid container direction='row' style={{ marginBottom: 5 }}>
                                  <Grid item xs={12} sm={12} md={12} lg={12} align='left'>
                                    <progress
                                      id='fht-senior-active-meter'
                                      className={classes.progressMeter}
                                      min={0}
                                      max={totalSeniors}
                                      value={activeSeniors}
                                      style={{ width: '100%' }}
                                    ></progress>
                                  </Grid>
                                </Grid>
                              )}

                              {renderStatRow(
                                'Modules 1-3 Completed',
                                seniorsCompletedModule123 + '/' + total123Modules,
                                total123Modules ? ((seniorsCompletedModule123 / total123Modules) * 100).toFixed(0) : 0
                              )}
                              <Grid container direction='row' style={{ marginBottom: 5 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} align='left'>
                                  <progress
                                    id='modules-123-meter'
                                    className={classes.progressMeter}
                                    min={0}
                                    max={total123Modules}
                                    value={seniorsCompletedModule123}
                                    style={{ width: '100%' }}
                                  ></progress>
                                </Grid>
                              </Grid>
                              <Grid container direction='row' style={{ marginBottom: 5 }} />
                              {renderStatRow(
                                'Modules 4-7 Completed',
                                seniorsCompletedModule4567 + '/' + total4567Modules,
                                total4567Modules ? ((seniorsCompletedModule4567 / total4567Modules) * 100).toFixed(0) : 0
                              )}
                              <Grid container direction='row' style={{ marginBottom: 5 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} align='left'>
                                  <progress
                                    id='modules-4567-meter'
                                    className={classes.progressMeter}
                                    min={0}
                                    max={total4567Modules}
                                    value={seniorsCompletedModule4567}
                                    style={{ width: '100%' }}
                                  ></progress>
                                </Grid>
                              </Grid>
                            </React.Fragment>
                          )}
                        </CardBody>
                      </Card>

                      {isAdmin(auth.roles) && (
                        <>
                          <Card className={classes.cardSize}>
                            <CardBody>
                              {isAdmin(auth.roles) && (
                                <React.Fragment>
                                  <section className={classes.menuTitle + ' ' + classes.pointerCursor} onClick={handleViewAlumniList}>
                                    Alumni
                                  </section>
                                  <aside className={classes.menuDesc}>List of alumni.</aside>
                                  {renderStatRow('Active Alumni', totalAlumni)}
                                  {renderStatRow('Pending access requests', accessRequests, null, true, handleViewAccessRequests)}
                                  {renderStatRow('Denied access requests', deniedAccessRequests)}

                                  <Grid container direction='row' style={{ marginBottom: 15 }} />
                                </React.Fragment>
                              )}
                            </CardBody>
                          </Card>

                          <Card className={classes.cardSize}>
                            <CardBody>
                              {isAdmin(auth.roles) && (
                                <React.Fragment>
                                  <section className={classes.menuTitle + ' ' + classes.pointerCursor} onClick={handleViewScholarshipApps}>
                                    Scholarship Applications
                                  </section>
                                  <aside className={classes.menuDesc}>List of active scholarship applications.</aside>

                                  <Grid container direction='row' style={{ marginBottom: 0 }}>
                                    <Grid item xs={9} sm={8} md={8} lg={8} align='left'>
                                      <summary className={classes.statName}>Submitted applications</summary>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statName}>{newScholarshipApplications}</summary>
                                    </Grid>
                                  </Grid>
                                  <Grid container direction='row' style={{ marginBottom: 0 }}>
                                    <Grid item xs={9} sm={8} md={8} lg={8} align='left'>
                                      <summary className={classes.statName}>Reviewed applications</summary>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statName}>{reviewedScholarshipApplications}</summary>
                                    </Grid>
                                  </Grid>
                                  <Grid container direction='row' style={{ marginBottom: 0 }}>
                                    <Grid item xs={9} sm={8} md={8} lg={8} align='left'>
                                      <summary className={classes.statName}>Ready for Committee Review applications</summary>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statName}>{underReviewScholarshipApplications}</summary>
                                    </Grid>
                                  </Grid>
                                </React.Fragment>
                              )}
                            </CardBody>
                          </Card>

                          <Card className={classes.cardSize}>
                            <CardBody>
                              {isAdmin(auth.roles) && (
                                <React.Fragment>
                                  <section className={classes.menuTitle + ' ' + classes.pointerCursor} onClick={handleViewAftercareApps}>
                                    Successful Futures Applications
                                  </section>
                                  <aside className={classes.menuDesc}>List of Successful Futures services applications.</aside>

                                  <Grid
                                    container
                                    direction='row'
                                    style={{ marginBottom: 0 }}
                                    className={classes.pointerCursor}
                                    onClick={handleViewTradelifeAftercareApps}
                                  >
                                    <Grid item xs={9} sm={8} md={8} lg={8} align='left'>
                                      <summary className={classes.statLink}>Community Supports</summary>
                                    </Grid>
                                    <Grid item xs={2} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statValue}>{tradelifeApps}</summary>
                                    </Grid>
                                    <Grid item xs={1} sm={1} md={1} lg={1} align='left' />
                                  </Grid>

                                  <Grid
                                    container
                                    direction='row'
                                    style={{ marginBottom: 0 }}
                                    className={classes.pointerCursor}
                                    onClick={handleViewTradelifeNewApps}
                                  >
                                    <Grid item xs={1} sm={1} md={1} lg={1} align='left' />
                                    <Grid item xs={8} sm={7} md={7} lg={7} align='left'>
                                      <summary className={classes.statLink}>New Applications</summary>
                                    </Grid>
                                    <Grid item xs={2} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statValue}>{tradelifeSubmittedApps}</summary>
                                    </Grid>
                                    <Grid item xs={1} sm={1} md={1} lg={1} align='left' />
                                  </Grid>

                                  <Grid
                                    container
                                    direction='row'
                                    style={{ marginBottom: 0 }}
                                    className={classes.pointerCursor}
                                    onClick={handleViewTradelifeInterviewApps}
                                  >
                                    <Grid item xs={1} sm={1} md={1} lg={1} align='left' />
                                    <Grid item xs={8} sm={7} md={7} lg={7} align='left'>
                                      <summary className={classes.statLink}>Interviews Scheduled</summary>
                                    </Grid>
                                    <Grid item xs={2} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statValue}>{tradelifeInterviewApps}</summary>
                                    </Grid>
                                  </Grid>

                                  <Grid
                                    container
                                    direction='row'
                                    style={{ marginBottom: 0 }}
                                    className={classes.pointerCursor}
                                    onClick={handleViewHousingAftercareApps}
                                  >
                                    <Grid item xs={9} sm={8} md={8} lg={8} align='left'>
                                      <summary className={classes.statLink}>Housing</summary>
                                    </Grid>
                                    <Grid item xs={2} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statValue}>{housingApps}</summary>
                                    </Grid>
                                  </Grid>

                                  <Grid
                                    container
                                    direction='row'
                                    style={{ marginBottom: 0 }}
                                    className={classes.pointerCursor}
                                    onClick={handleViewHousingNewApps}
                                  >
                                    <Grid item xs={1} sm={1} md={1} lg={1} align='left' />
                                    <Grid item xs={8} sm={7} md={7} lg={7} align='left'>
                                      <summary className={classes.statLink}>New Applications</summary>
                                    </Grid>
                                    <Grid item xs={2} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statValue}>{housingSubmittedApps}</summary>
                                    </Grid>
                                  </Grid>

                                  <Grid
                                    container
                                    direction='row'
                                    style={{ marginBottom: 0 }}
                                    className={classes.pointerCursor}
                                    onClick={handleViewHousingInterviewApps}
                                  >
                                    <Grid item xs={1} sm={1} md={1} lg={1} align='left' />
                                    <Grid item xs={8} sm={7} md={7} lg={7} align='left'>
                                      <summary className={classes.statLink}>Interviews Scheduled</summary>
                                    </Grid>
                                    <Grid item xs={2} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statValue}>{housingInterviewApps}</summary>
                                    </Grid>
                                  </Grid>
                                </React.Fragment>
                              )}
                            </CardBody>
                          </Card>

                          <Card className={classes.cardSize}>
                            <CardBody>
                              {isAdmin(auth.roles) && (
                                <React.Fragment>
                                  <section className={classes.menuTitle + ' ' + classes.pointerCursor} onClick={handleViewHelpApps}>
                                    Help Requests
                                  </section>
                                  <aside className={classes.menuDesc}>List of pending Help requests.</aside>
                                  {renderStatRow('Pending help applications', totalPendingHelpApplications)}
                                  {renderStatRow('Closed help applications', totalClosedHelpApplications)}
                                </React.Fragment>
                              )}
                            </CardBody>
                          </Card>
                          {isScholarshipCoordinatorUser && (
                            <Card className={classes.cardSize}>
                              <CardBody>
                                <React.Fragment>
                                  <section className={classes.menuTitle + ' ' + classes.pointerCursor} onClick={handleViewAwardPaymentRequest}>
                                    Award Payment Requests
                                  </section>
                                  <aside className={classes.menuDesc}>List of award payment requests.</aside>

                                  <Grid container direction='row' style={{ marginBottom: 0 }}>
                                    <Grid item xs={9} sm={8} md={8} lg={8} align='left'>
                                      <summary className={classes.statName}>Submitted award payment requests</summary>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statName}>{totalNumberOfRequest}</summary>
                                    </Grid>
                                  </Grid>
                                  <Grid container direction='row' style={{ marginBottom: 0 }}>
                                    <Grid item xs={9} sm={8} md={8} lg={8} align='left'>
                                      <summary className={classes.statName}>More Info Needed requests</summary>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statName}>{noOfRequestInPending}</summary>
                                    </Grid>
                                  </Grid>
                                  <Grid container direction='row' style={{ marginBottom: 0 }}>
                                    <Grid item xs={9} sm={8} md={8} lg={8} align='left'>
                                      <summary className={classes.statName}>Under Review requests</summary>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statName}>{noOfRequestUnderReview}</summary>
                                    </Grid>
                                  </Grid>
                                  <Grid container direction='row' style={{ marginBottom: 0 }}>
                                    <Grid item xs={9} sm={8} md={8} lg={8} align='left'>
                                      <summary className={classes.statName}>Approved - Pending Payment requests</summary>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} align='right'>
                                      <summary className={classes.statName}>{noOfRequestApprovedPendingPayment}</summary>
                                    </Grid>
                                  </Grid>
                                </React.Fragment>
                              </CardBody>
                            </Card>
                          )}
                        </>
                      )}
                      {isAdmin(auth.roles) && (
                        <Card className={classes.cardSize}>
                          <CardBody>
                            <React.Fragment>
                              <section className={classes.menuTitle + ' ' + classes.pointerCursor} onClick={handleViewContacts}>
                                Proactive Check-Ins
                              </section>
                              <aside className={classes.menuDesc}>List of proactive check-ins.</aside>
                              {renderStatRow('Pending Proactive Check-Ins', totalPendingContacts)}
                              {renderStatRow('Closed Proactive Check-Ins', totalClosedContacts)}
                            </React.Fragment>
                          </CardBody>
                        </Card>
                      )}
                      {isAdminOrFHT(auth.roles) && (
                        <div className={classes.myModulesWrapper}>
                          <Button className={classes.myModulesButton} variant='contained' onClick={handleMyModulesClick}>
                            My Planning Workbook
                          </Button>
                        </div>
                      )}
                    </div>
                    {staff && (
                      <PhoneDialog
                        message={warning}
                        staff={staff}
                        showDialog={showDialog}
                        handleClose={handleDialogClose}
                        handleSave={handleSavePhone}
                      />
                    )}
                  </React.Fragment>
                )}
              </>
            )}
            <div className={pageClasses.footer}>
              <div>&copy; {year} Boys Town. All Rights Reserved.</div>
              <div className={pageClasses.version}>Version 2.3.0</div>
            </div>
          </div>
        </div>
      </div>
    );
  })
);

export default Index;
